import { employeePayrollTypes } from '../types/employeePayrollTypes';
import { calculateWeeklyHours } from '../../utils/helpers/TotalHoursFormat';

const initialState = {
  employeePayroll: [],
  loading: false,
  error: null,
  dateStart: '',
  weekActive: true
};

export const employeePayrollReducer = (state = initialState, action) => {
  switch (action.type) {
    case employeePayrollTypes.SET_EMPLOYEE_PAYROLL:
      return {
        ...state,
        employeePayroll: action.payload.employees || action.payload,
        dateStart: action.payload.dateStart || ''
      };
    case employeePayrollTypes.FIND_EMPLOYEE_PAYROLL:
      return state;
    case employeePayrollTypes.SAVE_EMPLOYEE_PAYROLL:
      return state;
    case employeePayrollTypes.CHANGE_EMPLOYEE_PAYROLL_CELL: {
      const { payrollId, personId, key, value, day } = action.payload;
      let { employeePayroll, dateStart } = state;
      if (employeePayroll) {
        employeePayroll = employeePayroll.map((employee) => {
          if (employee.person?.personId === personId && employee[day]?.payrollId === payrollId) {
            const updatedEmployee = {
              ...employee,
              [day]: {
                ...employee[day],
                [key]: parseFloat(value) || 0
              }
            };

            return calculateWeeklyHours(updatedEmployee, dateStart);
          }
          return employee;
        });
      }
      return {
        ...state,
        employeePayroll
      };
    }
    case employeePayrollTypes.APPLY_TO_ALL_EMPLOYEE_PAYROLL: {
      const { totalRegHour } = action.payload;
      const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
      const regHours = parseFloat(totalRegHour) || 0;
      let { employeePayroll, dateStart } = state;
      if (employeePayroll) {
        employeePayroll = employeePayroll.map((employee) => {
          let updatedEmployee = { ...employee };
          days.forEach((day) => {
            if (updatedEmployee[day] && !updatedEmployee[day].lockPayroll) {
              updatedEmployee = {
                ...updatedEmployee,
                [day]: { ...updatedEmployee[day], totalRegHour: regHours, totalOtHour: updatedEmployee[day].totalOtHour ?? 0 }
              };
            }
          });
          return calculateWeeklyHours(updatedEmployee, dateStart);
        });
      }
      return { ...state, employeePayroll };
    }
    case employeePayrollTypes.SET_WEEK_ACTIVE_EMPLOYEE_PAYROLL:
      return { ...state, weekActive: action.payload };
    case employeePayrollTypes.RESET_EMPLOYEE_PAYROLL:
      return initialState;
    default:
      return state;
  }
};
